(() => {
  const boot = () => document.querySelectorAll('[data-fwip]:not([data-fwip-ready])').forEach(init);

  function init(root) {
    root.dataset.fwipReady = 'true';
    const state = new Map();
    const cards = [...root.querySelectorAll('[data-fwip-item]')];
    const currency = root.dataset.currency || 'USD';
    const routesRoot = window.Shopify?.routes?.root || '/';
    let activePhone = root.dataset.phone || 'iPhone 18 Pro Max';
    let activeLook = root.dataset.look || 'Gold';

    const els = {
      phones: [...root.querySelectorAll('[data-fwip-phone]')],
      looks: [...root.querySelectorAll('[data-fwip-look]')],
      tabs: [...root.querySelectorAll('[data-fwip-tab]')],
      panels: [...root.querySelectorAll('[data-fwip-panel]')],
      count: root.querySelector('[data-fwip-count]'),
      runningTotal: root.querySelector('[data-fwip-running-total]'),
      fitNote: root.querySelector('[data-fwip-fit-note]'),
      summary: root.querySelector('[data-fwip-summary]'),
      subtotal: root.querySelector('[data-fwip-subtotal]'),
      savingRow: root.querySelector('[data-fwip-saving-row]'),
      saving: root.querySelector('[data-fwip-saving]'),
      total: root.querySelector('[data-fwip-total]'),
      add: root.querySelector('[data-fwip-add]'),
      status: root.querySelector('[data-fwip-status]')
    };

    const money = cents => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency', currency
        }).format((Number(cents) || 0) / 100);
      } catch (_) {
        return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
      }
    };

    const dataFor = card => ({
      id: String(card.dataset.id || ''),
      productId: String(card.dataset.productId || ''),
      title: card.dataset.title || 'Product',
      role: card.dataset.role || 'extra',
      group: card.dataset.group || '',
      phone: card.dataset.phone || '',
      look: card.dataset.look || '',
      price: Number(card.dataset.price || 0),
      compare: Number(card.dataset.compare || 0),
      available: card.dataset.available === 'true',
      lensFilterFit: card.dataset.lensFilterFit || '',
      lensThread: card.dataset.lensThread || '',
      includes: String(card.dataset.includes || '').split(',').map(value => value.trim()).filter(Boolean),
      quantity: 0
    });

    const selected = () => [...state.values()].filter(item => item.quantity > 0);

    const metrics = () => {
      const items = selected();
      const units = items.reduce((sum, item) => sum + item.quantity, 0);
      const subtotal = items.reduce((sum, item) => sum + item.price * item.quantity, 0);
      const compareTotal = items.reduce((sum, item) => {
        const compare = item.compare > item.price ? item.compare : item.price;
        return sum + compare * item.quantity;
      }, 0);
      return { items, units, subtotal, saving: Math.max(0, compareTotal - subtotal) };
    };

    const includedMap = () => {
      const included = new Map();
      selected().filter(item => item.role === 'setup').forEach(setup => {
        setup.includes.forEach(id => {
          if (!included.has(id)) included.set(id, { quantity: 0, setups: 0 });
          const value = included.get(id);
          value.quantity += setup.quantity;
          value.setups += 1;
        });
      });
      return included;
    };

    const isCompatible = card => {
      const group = card.dataset.group || '';
      if (!group) return true;
      if (card.dataset.phone !== activePhone) return false;
      if ((group === 'cine' || group === 'mega') && card.dataset.look !== activeLook) return false;
      return true;
    };

    const updateCompatibility = (migrateSelections = true) => {
      const groups = [...new Set(cards.map(card => card.dataset.group || '').filter(Boolean))];
      const quantities = new Map();

      if (migrateSelections) {
        groups.forEach(group => {
          let quantity = 0;
          cards.filter(card => card.dataset.group === group).forEach(card => {
            const id = String(card.dataset.id || '');
            quantity += state.get(id)?.quantity || 0;
            state.delete(id);
          });
          if (quantity) quantities.set(group, quantity);
        });
      }

      cards.forEach(card => {
        if (!card.dataset.group) return;
        card.hidden = !isCompatible(card);
      });

      if (migrateSelections) {
        quantities.forEach((quantity, group) => {
          const target = cards.find(card => card.dataset.group === group && isCompatible(card));
          if (!target || target.dataset.available !== 'true') return;
          const item = dataFor(target);
          item.quantity = Math.min(99, quantity);
          state.set(item.id, item);
        });
      }

      els.phones.forEach(button => {
        const active = button.dataset.fwipPhone === activePhone;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      els.looks.forEach(button => {
        const active = button.dataset.fwipLook === activeLook;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      render();
    };

    const setQuantity = (card, next) => {
      const item = dataFor(card);
      if (!item.id || !item.available) return;
      const quantity = Math.max(0, Math.min(99, Number(next) || 0));
      if (quantity === 0) state.delete(item.id);
      else {
        item.quantity = quantity;
        state.set(item.id, item);
      }
      render();
    };

    const changeVariant = (card, select) => {
      const option = select.selectedOptions[0];
      if (!option) return;

      const oldId = String(card.dataset.id || '');
      const oldQuantity = state.get(oldId)?.quantity || 0;
      state.delete(oldId);

      card.dataset.id = option.dataset.id || option.value || '';
      card.dataset.price = option.dataset.price || '0';
      card.dataset.compare = option.dataset.compare || '0';
      card.dataset.available = option.dataset.available || 'false';

      const available = card.dataset.available === 'true';
      const image = card.querySelector('.fwip-card__media img');
      const price = card.querySelector('[data-fwip-price]');
      const compare = card.querySelector('[data-fwip-compare]');
      const link = card.querySelector('.fwip-card__link');
      const compareCents = Number(card.dataset.compare || 0);
      const priceCents = Number(card.dataset.price || 0);

      if (image && option.dataset.image) image.src = option.dataset.image;
      if (price) price.textContent = money(priceCents);
      if (compare) {
        compare.hidden = compareCents <= priceCents;
        compare.textContent = compareCents > priceCents ? money(compareCents) : '';
      }
      if (link && option.dataset.url) link.href = option.dataset.url;
      card.classList.toggle('is-soldout', !available);

      if (oldQuantity && available) {
        const item = dataFor(card);
        item.quantity = oldQuantity;
        state.set(item.id, item);
      }
      render();
    };

    const render = () => {
      const current = metrics();
      const included = includedMap();
      const lenses = current.items.filter(item => item.role === 'lens');
      const compatibleLenses = lenses.filter(item => item.lensFilterFit === 'true');
      const incompatibleLenses = lenses.filter(item => item.lensFilterFit === 'false');
      const hasCaseFilter = current.items.some(item => item.role === 'filter');
      const hasLensFilter = current.items.some(item => item.role === 'lens-filter');

      if (els.fitNote) {
        const messages = [];
        if (hasLensFilter && lenses.length) {
          if (compatibleLenses.length) {
            messages.push(`Slide-on filter fits ${compatibleLenses.map(item => item.title).join(', ')} (58mm).`);
          }
          if (incompatibleLenses.length) {
            const details = incompatibleLenses.map(item => {
              const fit = item.lensThread === 'none' ? 'no front thread' : item.lensThread === '43mm' ? '43mm adapter included' : item.lensThread;
              return `${item.title} (${fit})`;
            });
            messages.push(`Slide-on filter does not fit ${details.join(', ')}.`);
          }
        }
        if (lenses.length && hasCaseFilter) messages.push('Case filters fit the case, not lenses.');
        els.fitNote.hidden = messages.length === 0;
        els.fitNote.textContent = messages.join(' ');
        els.fitNote.classList.toggle('is-warning', incompatibleLenses.length > 0 && hasLensFilter);
      }

      cards.forEach(card => {
        const id = String(card.dataset.id || '');
        const quantity = state.get(id)?.quantity || 0;
        const inclusion = included.get(id);
        const includedQuantity = inclusion?.quantity || 0;
        const toggle = card.querySelector('[data-fwip-toggle]');
        const minus = card.querySelector('[data-fwip-minus]');
        const plus = card.querySelector('[data-fwip-plus]');
        const output = card.querySelector('[data-fwip-qty]');
        const cardState = card.querySelector('[data-fwip-state]');
        const note = card.querySelector('[data-fwip-included]');
        const compatibilityNote = card.querySelector('[data-fwip-card-compat]');

        card.classList.toggle('is-selected', quantity > 0);
        card.classList.toggle('is-included', includedQuantity > 0);
        if (toggle) {
          toggle.setAttribute('aria-pressed', quantity > 0 ? 'true' : 'false');
          toggle.disabled = card.dataset.available !== 'true';
        }
        if (minus) minus.disabled = quantity <= 0;
        if (plus) plus.disabled = card.dataset.available !== 'true' || quantity >= 99;
        if (output) output.textContent = String(quantity);

        if (cardState) {
          cardState.textContent = includedQuantity
            ? (quantity ? `${quantity} extra selected` : `${includedQuantity} included`)
            : (quantity ? 'Added' : (card.dataset.available === 'true' ? 'Add' : 'Sold out'));
        }
        if (note) {
          note.hidden = includedQuantity === 0;
          note.textContent = includedQuantity
            ? `Already included in your selected kit. Use + if you want ${includedQuantity === 1 ? 'another' : 'more'}.`
            : '';
        }
        if (compatibilityNote) {
          const showCompatibilityWarning = quantity > 0
            && card.dataset.role === 'lens'
            && card.dataset.lensFilterFit === 'false'
            && hasLensFilter;
          compatibilityNote.hidden = !showCompatibilityWarning;
          compatibilityNote.textContent = showCompatibilityWarning
            ? (card.dataset.lensThread === '43mm'
              ? '⚠ Not compatible with Slide-On Lens Filters. Use the included 43mm adapter.'
              : '⚠ Not compatible with Slide-On Lens Filters. This lens has no front filter thread.')
            : '';
        }
      });

      const itemWord = current.units === 1 ? 'item' : 'items';
      if (els.count) els.count.textContent = current.units ? `${current.units} ${itemWord} selected` : 'No items selected';
      if (els.runningTotal) els.runningTotal.textContent = money(current.subtotal);
      if (els.summary) els.summary.hidden = current.units === 0;
      if (els.subtotal) els.subtotal.textContent = money(current.subtotal);
      if (els.savingRow) els.savingRow.hidden = current.saving === 0;
      if (els.saving) els.saving.textContent = `−${money(current.saving)}`;
      if (els.total) els.total.textContent = money(current.subtotal);
      if (els.add) {
        els.add.disabled = current.units === 0;
        els.add.textContent = current.units ? `Add ${current.units} ${itemWord} to cart` : 'Add selected items to cart';
      }
    };

    const selectTab = requested => {
      const tab = els.tabs.some(button => button.dataset.fwipTab === requested) ? requested : 'filters';
      els.tabs.forEach(button => {
        const active = button.dataset.fwipTab === tab;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      els.panels.forEach(panel => {
        const active = panel.dataset.fwipPanel === tab;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    };

    els.phones.forEach(button => button.addEventListener('click', () => {
      activePhone = button.dataset.fwipPhone || activePhone;
      updateCompatibility(true);
    }));
    els.looks.forEach(button => button.addEventListener('click', () => {
      activeLook = button.dataset.fwipLook || activeLook;
      updateCompatibility(true);
    }));
    els.tabs.forEach(button => button.addEventListener('click', () => selectTab(button.dataset.fwipTab)));

    cards.forEach(card => {
      const variantSelect = card.querySelector('[data-fwip-variant]');
      variantSelect?.addEventListener('change', () => changeVariant(card, variantSelect));
      card.querySelector('[data-fwip-toggle]')?.addEventListener('click', () => {
        const quantity = state.get(String(card.dataset.id || ''))?.quantity || 0;
        setQuantity(card, quantity ? 0 : 1);
      });
      card.querySelector('[data-fwip-minus]')?.addEventListener('click', () => {
        const quantity = state.get(String(card.dataset.id || ''))?.quantity || 0;
        setQuantity(card, quantity - 1);
      });
      card.querySelector('[data-fwip-plus]')?.addEventListener('click', () => {
        const quantity = state.get(String(card.dataset.id || ''))?.quantity || 0;
        setQuantity(card, quantity + 1);
      });
    });

    const currentVariant = String(root.dataset.currentVariant || '');
    const pageCard = currentVariant ? cards.find(card => String(card.dataset.id || '') === currentVariant) : null;
    if (pageCard?.dataset.phone) activePhone = pageCard.dataset.phone;
    if (pageCard?.dataset.look) activeLook = pageCard.dataset.look;
    updateCompatibility(false);

    const preselectCard = pageCard || (root.dataset.preselectGroup
      ? cards.find(card => card.dataset.group === root.dataset.preselectGroup && isCompatible(card))
      : null);
    if (preselectCard && preselectCard.dataset.available === 'true') {
      const item = dataFor(preselectCard);
      item.quantity = 1;
      state.set(item.id, item);
    }
    const initialPanel = preselectCard?.closest('[data-fwip-panel]')?.dataset.fwipPanel || 'filters';
    selectTab(initialPanel);
    render();

    const cartQuantities = cart => {
      const quantities = new Map();
      (cart.items || []).forEach(item => {
        const id = String(item.variant_id || item.id || '');
        quantities.set(id, (quantities.get(id) || 0) + Number(item.quantity || 0));
      });
      return quantities;
    };

    els.add?.addEventListener('click', async () => {
      const current = metrics();
      if (!current.units) return;
      els.add.disabled = true;
      els.add.textContent = 'Adding and checking your setup…';
      if (els.status) els.status.textContent = '';

      try {
        const beforeResponse = await fetch(`${routesRoot}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (!beforeResponse.ok) throw new Error('The cart could not be checked. Please refresh and try again.');
        const before = cartQuantities(await beforeResponse.json());
        const items = current.items.map(item => ({ id: Number(item.id), quantity: item.quantity }));

        const addResponse = await fetch(`${routesRoot}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await addResponse.json().catch(() => ({}));
        if (!addResponse.ok) throw new Error(result.description || result.message || 'Some products could not be added.');

        const afterResponse = await fetch(`${routesRoot}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (!afterResponse.ok) throw new Error('Your cart could not be verified. Please open the cart and check the items.');
        const after = cartQuantities(await afterResponse.json());
        const missing = items.filter(item => (after.get(String(item.id)) || 0) < (before.get(String(item.id)) || 0) + item.quantity);
        if (missing.length) throw new Error('Some items were not confirmed in the cart. Please refresh and try again.');
        window.location.assign(`${routesRoot}cart`);
      } catch (error) {
        if (els.status) els.status.textContent = error.message || 'Please try again.';
        render();
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
